import "../../assets/css/font.css.ts.vanilla.mjs";
import "./ScrollContainer.css.ts.vanilla.mjs";
var _ = "p273__ScrollContainer-cb3a_fc7235df6__ccf6uv2", o = "p273__ScrollContainer-cb3a_fc7235df6__ccf6uv1", a = "p273__ScrollContainer-cb3a_fc7235df6__ccf6uv0";
export {
  _ as scrollBar,
  o as scrollContatiner,
  a as scrollContatinerWrapper
};
//# sourceMappingURL=ScrollContainer2.mjs.map
